import Lenis from "lenis";
import { useEffect } from "react";
import { setLenisInstance } from "../lib/scroll";

type UseLenisOptions = {
  enabled: boolean;
};

export function useLenis({ enabled }: UseLenisOptions) {
  useEffect(() => {
    if (!enabled) {
      setLenisInstance(null);
      return;
    }

    let lenis: Lenis | null = null;
    let cleanup = () => {};

    void import("gsap").then(({ default: gsap }) => {
      lenis = new Lenis({
        duration: 1.15,
        smoothWheel: true,
        syncTouch: false,
        touchMultiplier: 1.05
      });

      setLenisInstance(lenis);

      const update = (time: number) => {
        lenis?.raf(time * 1000);
      };

      gsap.ticker.add(update);
      gsap.ticker.lagSmoothing(0);

      cleanup = () => {
        gsap.ticker.remove(update);
        lenis?.destroy();
        setLenisInstance(null);
      };
    });

    return () => {
      cleanup();
    };
  }, [enabled]);
}
